let scheduled = false;
/** Update after load plus idle, even when startup fails before the first rendered frame.
 * The top-level player owns registration; its embedded simulator never competes.
 */
function registerWhenIdle(): void {
  if (scheduled || !import.meta.env.PROD || window.parent !== window || !('serviceWorker' in navigator)) return;
  scheduled = true;
  const install = () => { void navigator.serviceWorker.register('/sw.js', {updateViaCache: 'none'})
    .then(registration => {
      const cleanup = () => {
        const active = registration.active;
        if (registration.installing || registration.waiting || !active) return;
        if (active.state === 'activated') active.postMessage({type: 'bubbles:cleanup'});
        else active.addEventListener('statechange', cleanup, {once: true});
      };
      navigator.serviceWorker.addEventListener('controllerchange', cleanup);
      cleanup();
    }).catch(() => {}); };
  // Safari lacks requestIdleCallback. The fallback still runs independently of rendering.
  if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(install, {timeout: 30000});
  else setTimeout(install, 1000);
}

/** Compatibility notification: registration no longer depends on rendering success. */
export function notifyFirstCompleteFrame(): void {
  if (import.meta.env.PROD && document.readyState === 'complete') registerWhenIdle();
}

if (typeof window !== 'undefined' && import.meta.env.PROD && window.parent === window) {
  if (document.readyState === 'complete') registerWhenIdle();
  else window.addEventListener('load', registerWhenIdle, {once: true});
}
